export default "__VITE_ASSET__DR0vBXA2__"